module.exports = __webpack_public_path__ + "static/media/26years.b23cb949.png";